import { Injectable } from '@angular/core';

import { JumpListItem, JumpListService } from './jump-list.service';

@Injectable()
export class OfficeHomeJumpListService implements JumpListService {

    public registerRecommendedJumpList(): void {
        return;
    }

    public registerRecentJumpList(): void {
        return;
    }

    public getJumpListItemById(): JumpListItem {
        return null;
    }
}